<div
  class="author-details-view-container"
  *ngIf="authorObject"
  fxLayout="column"
  fxLayoutGap="15px"
>
  <div fxLayout="row" fxLayoutGap="15px">
    <button
      [disabled]="!(userPermissions | async).dobry_agent.write"
      (click)="modify()"
      mat-stroked-button
      color="primary"
    >
      <mat-icon>create</mat-icon>
      <span> Edytuj </span>
    </button>
    <button
      (click)="deleteWeak(authorObject.uuid)"  mat-stroked-button >
      <mat-icon>archive</mat-icon>
      <span> Przenieś do archiwum</span>
    </button>
    <button
      (click)="delete(authorObject)"  mat-stroked-button color="warn">
      <mat-icon>delete</mat-icon>
      <span> Usuń</span>
    </button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <mat-card fxLayout="column">

        <app-section-header
          title="Dane autora"
          description="Dane prezentowane przy artykułach."
        ></app-section-header>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <app-detail
              header="Imię"
              [value]="authorObject.firstName"
            ></app-detail>
          </div>
          <div fxFlex="50">
            <app-detail
              header="Nazwisko"
              [value]="authorObject.lastName"
            ></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail
              header="Opis"
            ><span [innerHTML]="authorObject.description"></span></app-detail>
          </div>
        </div>
        <img
          *ngIf="authorObject.imagePath"
          class="author-image-preview"
          [src]="authorObject.imagePath"
          [alt]="authorObject.altImage || 'Zdjęcie autora'"
        >
        <ng-container *ngIf="!authorObject.imagePath" >
          <img class="author-avatar" style="margin-top:15px"
               [src]="'/assets/avatar.png'"
               alt="Zdjęcie"/>
          <span style="margin-top:15px">Brak zdjęcia</span>
        </ng-container>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail
              header="Alt obrazka"
              [value]="authorObject.altImage"
            ></app-detail>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <app-detail
              header="Status"
            >
              <app-detail-bool
                [header]="authorObject.active ? 'Aktywny': 'Nieaktywny'"
                [value]="authorObject.active"
              ></app-detail-bool>
            </app-detail>
          </div>
        </div>

      </mat-card>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card fxLayout="column">
        <app-section-header
          title="Użytkownik ASF24"
          description="Powiązane konto użytkownika w systemie ASF24."
        ></app-section-header>
        <ng-container *ngIf="userObject">
          <div fxLayout="column" fxFlex="100">
            <ng-container *ngIf="userObject.uuid">
              <app-detail
                fxFlex="100"
                header="Użytkownik"
              >
                <a class="default-link"
                   [routerLink]="['/uzytkownicy/szczegoly', userObject.uuid]">{{ userObject.firstName + ' ' + userObject.lastName }}</a>
              </app-detail>
              <div fxLayout="row" fxFlex="100">
                <div fxFlex="50">
                  <app-detail header="Email"
                              [value]="userObject.email">

                  </app-detail>
                </div>
                <div fxFlex="50">
                  <app-detail header="Telefon"
                              [value]="userObject.phone">
                  </app-detail>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="partnerObject">
              <app-detail
                fxFlex="100"
                header="Partner"
              >
                <a class="default-link"
                   [routerLink]="['/partnerzy/szczegoly', partnerObject.uuid]">{{ partnerObject?.shortName }}</a>
              </app-detail>
            </ng-container>

            <ng-container *ngIf="ofwcaObject">
              <app-detail
                fxFlex="100"
                header="OFWCA"
              >
                <a class="default-link"
                   [routerLink]="['/ofwca/szczegoly',ofwcaObject.uuid]">{{ ofwcaObject.fullName }}</a>
              </app-detail>

            </ng-container>

          </div>
        </ng-container>
      </mat-card>
      <mat-card fxLayout="column">
        <app-section-header
          title="Dane doradcy"
          description="Dane prezentowane na stronie dobryagent.pl."
        ></app-section-header>
        <ng-container *ngIf="authorObject.agent">
          <div fxLayout="row" fxFlex="100">
            <div fxFlex="50">
              <app-detail header="Imię"
                          [value]="authorObject.agent.firstName">

              </app-detail>
            </div>
            <div fxFlex="50">
              <app-detail header="Nazwisko"
                          [value]="authorObject.agent.lastName">

              </app-detail>
            </div>
          </div>
          <div fxLayout="row" fxFlex="100">
            <div fxFlex="50">
              <app-detail header="Email"
                          [value]="authorObject.agent.email">

              </app-detail>
            </div>
            <div fxFlex="50">

              <app-detail header="Telefon"
                          [value]="authorObject.agent.phone">
              </app-detail>
            </div>
          </div>
          <app-detail
            fxFlex="100"
            header="Status"
          >
            <app-detail-bool
              [header]="authorObject.active ? 'Aktywny': 'Nieaktywny'"
              [value]="authorObject.agent.active"
            ></app-detail-bool>
          </app-detail>
        </ng-container>
      </mat-card>

    </div>

  </div>
</div>
